import { render, staticRenderFns } from "./FuncionalidadeCustomizadaSolicitacaoComponent.vue?vue&type=template&id=64ec1ba2&scoped=true"
import script from "./FuncionalidadeCustomizadaSolicitacaoComponent.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaSolicitacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeCustomizadaSolicitacaoComponent.vue?vue&type=style&index=0&id=64ec1ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec1ba2",
  null
  
)

export default component.exports